
import { defineComponent, reactive, toRefs, onMounted, watch } from "vue";
import {
  getSensitiveFields,
  setAppApiSensitiveField,
  getAppApiSensitiveFields,
} from "@/service/api";
import { ElMessage } from "element-plus";
export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    appId: {
      type: String,
      default: "",
    },
    schoolId: {
      type: String,
      default: "",
    },
  },
  emits: ["add-submit", "close-modal"],
  setup(props, context) {
    const state = reactive({
      fields: [] as any[],
      sensitiveFields: [],
      appApiSensitiveFields: [],
      clickModalClose: false,
    });
    //获取敏感字段
    async function queryFields() {
      const params = {
        type: 0,
      };
      const result = await getSensitiveFields(params);
      if (result && parseInt(result.code) === 1) {
        state.sensitiveFields = result.data;
      }
    }
    //点击确认
    async function addSubmit() {
      const params = {
        appId: props.appId,
        schoolId: props.schoolId,
        fields: state.fields.toString(),
      };
      const result = await setAppApiSensitiveField(params);
      if (result && parseInt(result.code) === 1) {
        ElMessage({ message: "操作成功", type: "success" });
        cancel();
      } else {
        ElMessage({ message: "操作失败", type: "error" });
      }
    }
    //取消审核
    function cancel() {
      state.fields = [];
      state.appApiSensitiveFields = [];
      context.emit("close-modal");
    }
    //获取学校敏感字段
    async function getFields() {
      const params = {
        appId: props.appId,
        schoolId: props.schoolId,
      };
      const result = await getAppApiSensitiveFields(params);
      if (result && parseInt(result.code) === 1) {
        let names: any[] = [];
        result.data.forEach((item: any) => {
          names.push(item.fieldName);
        });
        state.fields = names;
      }
    }
    /**
     * 初始加载数据
     */
    onMounted(async () => {
      await queryFields();
    });
    watch(
      () => props.dialogVisible,
      async (newVal) => {
        if (newVal) {
          getFields();
        }
      }
    );
    return {
      ...toRefs(state),
      addSubmit,
      cancel,
    };
  },
});
